import React from 'react';
import { Box, Typography } from '@mui/material';
import { OBSIDIAN, OBSIDIAN_BODY_FONT, OBSIDIAN_DISPLAY_FONT } from '../../constants/obsidianDashboardTheme';

export function SandboxMetricCard({
    label,
    value,
    sub,
    subColor,
    valueColor,
    badge,
    icon,
}: {
    label: string;
    value: string;
    sub?: string;
    subColor?: string;
    valueColor?: string;
    badge?: number;
    icon: React.ReactNode;
}) {
    return (
        <Box
            sx={{
                p: 1.75,
                borderRadius: 3,
                bgcolor: OBSIDIAN.surfaceContainer,
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'space-between',
                minHeight: 96,
            }}>
            <Box
                sx={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    color: OBSIDIAN.onSurfaceVariant,
                }}>
                <Typography sx={{ fontSize: 12, fontFamily: OBSIDIAN_BODY_FONT }}>{label}</Typography>
                {badge != null ? (
                    <Box
                        sx={{
                            minWidth: 20,
                            height: 18,
                            px: 0.75,
                            borderRadius: 999,
                            bgcolor: '#ff7351',
                            color: '#fff',
                            fontSize: 10,
                            fontWeight: 700,
                            display: 'inline-flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                        }}>
                        {badge}
                    </Box>
                ) : (
                    icon
                )}
            </Box>
            <Box sx={{ mt: 1, display: 'flex', alignItems: 'baseline', gap: 0.75, flexWrap: 'wrap' }}>
                <Typography
                    sx={{
                        fontFamily: OBSIDIAN_DISPLAY_FONT,
                        fontWeight: 700,
                        fontSize: 20,
                        color: valueColor || OBSIDIAN.onSurface,
                    }}>
                    {value}
                </Typography>
                {sub && (
                    <Typography
                        sx={{
                            fontSize: 10,
                            fontFamily: OBSIDIAN_BODY_FONT,
                            color: subColor || OBSIDIAN.onSurfaceVariant,
                            fontWeight: subColor ? 700 : 400,
                        }}>
                        {sub}
                    </Typography>
                )}
            </Box>
        </Box>
    );
}

export function SandboxLaunchpadTile({
    icon,
    iconColor,
    title,
    subtitle,
    onClick,
}: {
    icon: React.ReactNode;
    iconColor: string;
    title: string;
    subtitle: string;
    onClick: () => void;
}) {
    return (
        <Box
            component="button"
            type="button"
            onClick={onClick}
            sx={{
                display: 'flex',
                alignItems: 'center',
                gap: 1.5,
                p: 1.5,
                borderRadius: 3,
                bgcolor: OBSIDIAN.surfaceContainer,
                border: 'none',
                textAlign: 'left',
                cursor: 'pointer',
                color: 'inherit',
                width: '100%',
                '&:active': { transform: 'scale(0.98)' },
            }}>
            <Box
                sx={{
                    width: 36,
                    height: 36,
                    borderRadius: 2,
                    bgcolor: OBSIDIAN.surfaceContainerHighest,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    color: iconColor,
                    flexShrink: 0,
                }}>
                {icon}
            </Box>
            <Box sx={{ minWidth: 0 }}>
                <Typography
                    sx={{ fontFamily: OBSIDIAN_DISPLAY_FONT, fontWeight: 700, fontSize: 12, color: OBSIDIAN.onSurface }}
                    noWrap>
                    {title}
                </Typography>
                <Typography
                    sx={{ fontFamily: OBSIDIAN_BODY_FONT, fontSize: 10, color: OBSIDIAN.onSurfaceVariant }}
                    noWrap>
                    {subtitle}
                </Typography>
            </Box>
        </Box>
    );
}
